import { render } from "./GalleryMenuItem.vue?vue&type=template&id=143f580c&scoped=true"
import script from "./GalleryMenuItem.vue?vue&type=script&lang=js"
export * from "./GalleryMenuItem.vue?vue&type=script&lang=js"

import "./GalleryMenuItem.vue?vue&type=style&index=0&id=143f580c&scoped=true&lang=scss"

import exportComponent from "/home/projects/endangeredlabs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143f580c"]])

export default __exports__